import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetSingleUser = async (UserID) => {
  try {
    const UsersCollection = collection(db, "Users");
    const UserDocument = doc(UsersCollection, UserID);
    const UserSnapshot = await getDoc(
      UserDocument,
      where("IsDeleted", "==", false),
      where("IsVerified", "==", 1)
    );

    let User = { ...UserSnapshot.data(), id: UserSnapshot.id };

    return User;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleUser;
